import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const useCustomCellRenderers = (
  handleEditClick: (data: any) => void
) => {
  const dispatch = useDispatch();
  const retainState = useSelector(
    (e: any) => e.retainState.schemeSummaryTabState
  );
  const caseRenderers = {
    nameCellRenderer: function (param: any) {
      return (
        <>
          {
            <Link
              to={`./scheme-manage/${param.data.id}`}
              state={{ from: param.data.id }}
              onClick={() => {
                if (
                  retainState.schemeVersionId !== param.data.id ||
                  retainState.schemeVersionId === ""
                ) {
                  dispatch(
                    setComponentState1({
                      entityName: "schemeSummaryTabState",
                      entityState: {
                        schemeVersionId: "",
                        isDraft: false,
                      },
                    })
                  );
                }
              }}
            >
              <span className="text-bold-underline">{param.data.name}</span>
            </Link>
          }
        </>
      );
    },
    // actionCellRenderers: function (param: any) {
    //     return (
    //         <div className="motif-row">
    //             {/* <div className="motif-col-lg-6">
    //                 <MotifButton
    //                     size="small"
    //                     variant="primary"
    //                     onClick={() => {
    //                         console.log('Delete claim');
    //                     }}
    //                 >
    //                     <MotifIcon
    //                         iconFunction={IconoirTrash}
    //                         stroke="blue"
    //                         strokeWidth="2"
    //                         size="24"
    //                     />
    //                 </MotifButton>
    //             </div> */}
    //             {/* <div className="motif-col-lg-6">
    //                 <MotifButton
    //                     onClick={()=> handleEditClick(param.data.id)}
    //                     size="small"
    //                     type="submit"
    //                     variant="primary"
    //                 >
    //                     <MotifIcon
    //                         iconFunction={IconoirEditPencil}
    //                         stroke="blue"
    //                         strokeWidth="2"
    //                         size="24"
    //                     />
    //                 </MotifButton>
    //             </div> */}
    //         </div>
    //     );
    // },
  };
  return caseRenderers;
};
